<template>
  <!-- Desktop: Segmented Control (hidden on small screens) -->
  <div class="hidden lg:block">
    <BaseSegmentedControl
      v-model="localValue"
      :options="options"
      @update:model-value="onUpdate"
    />
  </div>

  <!-- Mobile: Dropdown (hidden on larger screens) -->
  <div class="block lg:hidden">
    <BaseInputSelect
      v-model="localValue"
      :options="options"
      input-class="min-w-42"
      @update:model-value="onUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue: string | null;
  options: Array<{
    label: string;
    value: string | null;
  }>;
}>();

const emit = defineEmits<{
  (event: "update:modelValue", value: string | null): void;
}>();

const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const onUpdate = (value: string | null) => {
  emit("update:modelValue", value);
};
</script>
